import { FeedbackError } from "shared/errors";

export class FeedbackService {
  httpClient;
  baseUrl;

  constructor(baseUrl, apiClient) {
    this.httpClient = apiClient;
    this.baseUrl = baseUrl;
  }

  submitFeedback = async (data) => {
    const url = `${this.baseUrl}/interaction/feedback`;
    const response = await this.httpClient.post(url, data);
    // isSuccessful is only returned as false when an error has occurred
    if (response.isSuccessful === false) {
      throw new FeedbackError();
    }
    return response.data;
  };
}
